module.exports = __webpack_public_path__ + "static/img/references3.f24eafc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/references3.jpg
// module id = GIp0
// module chunks = 1